// extracted by mini-css-extract-plugin
module.exports = {"atendimentoConsulta":"Consultar_atendimentoConsulta__2wVJZ","containerPainel":"Consultar_containerPainel__3fnRp"};